module.exports = __webpack_public_path__ + "static/img/2.a65dfdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/2.png
// module id = RIGd
// module chunks = 0